import {Component, EventEmitter, OnInit, Output} from '@angular/core';


import {ProjectModel} from './project.model';
import {HolidayModel} from './holiday/holiday.model';
import {ProjectService} from '../core/ecv-http-services/services/project.service';
import {DialogService} from '../dialog/dialog.service';


@Component({
  selector: 'app-project',
  templateUrl: './project.component.html'
})
export class ProjectComponent implements OnInit {
  activeProjects: ProjectModel[];
  inactiveProjects: ProjectModel[];
  holidayDetails: HolidayModel;
  @Output() holidayRequest = new EventEmitter();
  selectedProjects: number[];

  constructor(private projectService: ProjectService,
              private dialogService: DialogService) {
  }

  ngOnInit() {
    this.loadActiveProjects();
    this.loadInactiveProjects();
    this.selectedProjects = [];
    this.holidayDetails = new HolidayModel();
  }

  openModal() {
    this.dialogService.openHolidayModal(this.activeProjects, this.holidayDetails);
  }

  loadActiveProjects() {
    this.projectService.getActiveProjects().subscribe(
      response => {
        this.activeProjects = response;
      });
  }

  loadInactiveProjects() {
    this.projectService.getInactiveProjects().subscribe(
      response => {
        this.inactiveProjects = response;
      });
  }

  parseObjectToJson(object) {
    return JSON.stringify(object);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/project.component.ts